var React = require('react');

function ContextMenuArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E5E5E5","fillRule":"evenodd","d":"M2.677 10.323L8.03 4.97l5.354 5.353-.707.707L8.03 6.384 3.384 11.03l-.707-.707z","clipRule":"evenodd"}));
}

ContextMenuArrowUp.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = ContextMenuArrowUp;

ContextMenuArrowUp.default = ContextMenuArrowUp;
